import React, { useEffect, useRef, useState } from 'react';
import { AgentSideMessages, MessageSideEnum, useChat } from './ChatContext';
import { GetChatSessionDetail } from '../../Controller/Api/ClientAgentController';
import { MesajiGonderenTarafEnum, Message } from '../../Model/Response/ClientAgent/GetChatSessionDetailResponse';
import { GlobalOperations } from '../../Controller/Common/GlobalOperations';
import RenderMessageContent from '../UserSide/renderMessageContent';

// ClientSideMessages modelini tanımlıyoruz
const MessageList: React.FC = () => {
    const { messages, setMessages, addMessage } = useChat();
    const [loading, setLoading] = useState<boolean>(false);
    const messageListRef = useRef<HTMLDivElement>(null);

    // API'den gelen verileri ClientSideMessages modeline dönüştüren yardımcı fonksiyon
    const mapToClientSideMessages = (message: Message): AgentSideMessages => {
        return {
            messageContent: message.messageContent,
            messageOwnerName: message.messageFrom,
            messageDateUtc: new Date(message.messageDate).getTime(), // UTC timestamp
            messageSide: message.side === MesajiGonderenTarafEnum.AlbinaSoft ? MessageSideEnum.Agent : MessageSideEnum.ClientUser,
        };
    };

    const fetchSessionDetails = async () => {
        if (GlobalOperations.ActiveSessionId != 0) {
            setLoading(true);
            try {
                let response = await GetChatSessionDetail(GlobalOperations.ActiveSessionId);
                if (response && response.content?.messageList) {
                    // Mesajları ClientSideMessages modeline mapleyip setMessages'e ekliyoruz
                    const mappedMessages = response.content.messageList.map(mapToClientSideMessages);
                    setMessages(mappedMessages);
                }
            } catch (error) {
                console.error('Mesajları alma hatası:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchSessionDetails();

    }, [GlobalOperations.ActiveSessionId]);

    useEffect(() => {
        if (!loading && messageListRef.current) {
            messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
        }
    }, [messages, loading]);

    const formatMessageDate = (dateUtc: number) => {
        const date = new Date(dateUtc);
        return new Intl.DateTimeFormat('tr-TR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        }).format(date);
    };

    const linkify = (text: string) => {
        // Hem http, https ile başlayan, hem de www. ile başlayan linkleri yakalamak için regex
        const urlRegex = /(\b(https?:\/\/|www\.)[^\s]+)/g;

        return text.replace(urlRegex, (url) => {
            // Eğer link www. ile başlıyorsa, başına http:// ekle
            if (url.startsWith('www.')) {
                return `<a href="http://${url}" target="_blank" style="color: inherit; text-decoration: underline;">${url}</a>`;
            }

            // Eğer http veya https ile başlıyorsa, direkt a tagına dönüştür
            return `<a href="${url}" target="_blank" style="color: inherit; text-decoration: underline;">${url}</a>`;
        });
    };



    return (
        <div className="message-list" ref={messageListRef} style={{ overflowY: 'auto', maxHeight: '100%' }}>
            {loading ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Yükleniyor...</span>
                    </div>
                </div>
            ) : messages.length === 0 ? (
                GlobalOperations.ActiveSessionId === 0 ? (
                    <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                        Oturum kapatıldı. Başka bir oturum seçebilirsiniz
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                        Bir konuşma seçin
                    </div>
                )
            ) : (
                messages.map((message, index) => {
                    const isAgent = message.messageSide === MessageSideEnum.Agent;
                    const isFileMessage = message.messageContent.startsWith('fileUrl:'); // Dosya URL'si ile başlıyor mu?

                    const bubbleStyle = {
                        marginBottom: '10px',
                        padding: '10px',
                        borderRadius: isAgent ? '1.125rem 1.125rem 0 1.125rem' : '1.125rem 1.125rem 1.125rem 0',
                        backgroundColor: isAgent ? '#2980b9' : '#333',
                        color: '#fff',
                        maxWidth: '60%',
                        alignSelf: isAgent ? 'flex-end' : 'flex-start',
                        textAlign: 'left' ,
                        marginLeft: isAgent ? 'auto' : '0',
                        marginRight: isAgent ? '0' : 'auto',
                    } as React.CSSProperties;

                    return (
                        <div key={index} className="message" style={bubbleStyle}>
                            {isFileMessage ? (
                                <RenderMessageContent url={message.messageContent.replace('fileUrl:', '')} />
                            ) : (
                                <div
                                    style={{ marginBottom: '5px', whiteSpace: 'pre-wrap' }}
                                    dangerouslySetInnerHTML={{ __html: linkify(message.messageContent) }}
                                />
                            )}
                            <div style={{ fontSize: '12px', color: '#ccc', marginTop: '5px' }}>
                                <strong>{message.messageOwnerName}</strong>
                                <span>{formatMessageDate(message.messageDateUtc)}</span>
                            </div>
                        </div>
                    );
                })
            )}
        </div>
    );
};

export default MessageList;
